import {OrdersToBeFilled, OrdersToBeDelivered, OrdersDelivered, OrdersStatus, Sales} from '../../components/charts'

const init = () => {
  OrdersToBeFilled()
  OrdersToBeDelivered()
  OrdersDelivered()
  OrdersStatus()
  Sales()
}

export default init
